import { object, string } from 'zod/mini';
import type { infer as Infer } from 'zod/mini';
import { describeField, switchField, withDefaults } from '@h20-shared/dashboards';
import { languageNames } from '@h20/contracts/utils/text/languageNames';

export const HTML_CONFIG_SCHEMA = withDefaults(
    object({
        /** Shown in every language that is switched off below, or switched on but left empty. */
        html: describeField(string(), {
            label: 'Dashboard.HtmlSettings.AllLanguages',
            multiline: true,
        }),
        /** One card per language code, such as `fr: { enabled: true, html: '<p>Salut</p>' }`. */
        languages: describeField(
            object(
                Object.fromEntries(
                    languageNames.map((language) => [
                        language.code,
                        describeField(
                            object({
                                enabled: switchField(language.label),
                                html: describeField(string(), {
                                    label: 'Dashboard.HtmlSettings.Content',
                                    multiline: true,
                                }),
                            }),
                            { label: language.label }
                        ),
                    ])
                )
            ),
            { label: 'Dashboard.HtmlSettings.Languages' }
        ),
    })
);

export type HtmlWidgetConfig = Infer<typeof HTML_CONFIG_SCHEMA>;
